import React, { useState, useEffect } from "react";
import { FormattedHTMLMessage, useIntl } from "gatsby-plugin-intl";
import ModalPopup from "../modal";
import "./twNoticeModal.scss";

const TwNoticeModal = () => {
  const [showModal, setShowModal] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <ModalPopup
      show={showModal}
      onClose={handleClose}
      heading={intl.formatMessage({ id: "twNoticeModalTitle" })}
      size="lg"
    >
      <hr className="tw-notice-modal-divider" />
      <div className="tw-notice-content">
        <FormattedHTMLMessage id="twNoticeModalContent" />
      </div>
    </ModalPopup>
  );
};

export default TwNoticeModal;
